window.autoSlideTestimonials;
window.testimonialsInterval;
window.testimonialsSection = document.querySelector('section.testimonials');

var testimonials = testimonialsSection ? testimonialsSection.querySelectorAll('blockquote') : false,
	testimonialImages = testimonialsSection ? testimonialsSection.querySelectorAll('.bg-container') : false;

if(testimonials.length > 1) {
	var currentTestimonial = 0,
		testimonialsLength = testimonials.length-1,
		testimonialsWaypoint = new Waypoint({
			element: testimonialsSection,
			handler: function(direction) {
				testimonialsInterval = setInterval(autoSlideTestimonials, 7000);

				this.destroy();
			},
			offset: '100%'
		});

	autoSlideTestimonials = function() {
		if(document.visibilityState === 'visible')
			setCurrentTestimonial('next');
	};
}

window.setCurrentTestimonial = function setCurrentTestimonial(isNext) {
	Velocity(testimonials[currentTestimonial], {opacity: [0,1]}, {duration: 600, display: currentTestimonial ? 'none' : 'block'});
	Velocity(testimonialImages[currentTestimonial], {opacity: [0,1]}, {duration: 600, display: 'none'});

	if(testimonialImages[currentTestimonial].classList.contains('loaded'))
		testimonialImages[currentTestimonial].classList.remove('loaded');

	currentTestimonial = isNext ? (currentTestimonial == testimonialsLength ? 0 : ++currentTestimonial) : (currentTestimonial == 0 ? testimonialsLength : --currentTestimonial);

	Velocity(testimonials[currentTestimonial], {opacity: [1,0]}, {duration: 600, display: 'block'});

	if(!testimonialImages[currentTestimonial].src)
		testimonialImages[currentTestimonial].src = testimonialImages[currentTestimonial].dataset.src;

	Velocity(testimonialImages[currentTestimonial], {opacity: [1,0]}, {duration: 600, display: 'block'});
}